import ProjectsConnect from "./ProjectsConnect.js";
import projects from "./projects.js";

const projectsConnect = new ProjectsConnect(projects);
const projectsArea = document.getElementById("projects-area");

projectsConnect.displayProjects(projectsArea);
